import apiClient from './apiClient';


// 获取产品详情
export const getProductDetails = (productId) => {
  return apiClient.get(`/wp-json/wc/v3/products/${productId}`);
};

// 添加到购物车
export const addToCart = (productId, quantity = 1) => {
  return apiClient.post('/wp-json/custom/v1/add-to-cart', {
    product_id: productId,
    quantity: quantity,
  })
  .then(response => response.data)
  .catch(error => {
    console.error('Error adding to cart:', error);
    throw error;
  });
};

// 获取地址
export const getAddresses = () => {
  return apiClient.get('/wp-json/api/user/addresses');
};

// 添加新地址
export const addNewAddress = (address) => {
  return apiClient.post('/wp-json/api/user/addresses', address);
};

// 删除地址
export const deleteAddress = (addressId) => {
  return apiClient.delete(`/wp-json/api/user/addresses/${addressId}`);
};
export const updateAddress = (addressId, address) => {
  return apiClient.put(`/wp-json/api/user/addresses/${addressId}`, address);
};
// 获取 USDT 价格
export const fetchUSDTPrice = () => {
  return apiClient.get('https://api.binance.com/api/v3/ticker/price?symbol=USDTUSD');
};

// 获取货币汇率
export const fetchCurrencyRate = () => {
  return apiClient.get('/wp-json/wc/v3/currency-rate');
};

// 检查交易状态
export const checkTransactionStatus = (txHash) => {
  return apiClient.get(`/api/check-transaction-status?txHash=${txHash}`);
};

// 更新订单状态
export const updateOrderStatus = (txHash, addressId) => {
  return apiClient.post('/wp-json/wc/v3/orders/update', {
    txHash,
    status: 'completed',
    address_id: addressId,
  });
};

// 获取公告
export const fetchAnnouncements = () => {
  return apiClient.get('/wp-json/wp/v2/announcement')
    .then(response => response.data)
    .catch(error => handleError(error));
};

// 获取介绍文本
export const fetchIntroText = () => {
  return apiClient.get('/wp-json/wp/v2/pages?slug=intro');
};

// 获取模型 URL
export const fetchModelUrl = () => {
  return apiClient.get('/wp-json/custom/v1/3d-viewer/24')
    .then(response => response.data)
    .catch(error => handleError(error));
};

// 获取合作伙伴
export const fetchPartners = () => {
  return apiClient.get('/wp-json/custom/v1/partners')
    .then(response => {
      // 假设合作伙伴信息存储在 `partners` 字段中
      return response.data;
    })
    .catch(error => handleError(error));
};

// 获取头部 Logo
export const fetchHeaderLogo = () => {
  return apiClient.get('/wp-json/wp/v2/header-logo');
};

// 获取底部 Logo
export const fetchFooterLogo = () => {
  return apiClient.get('/wp-json/wp/v2/footer-logo');
};

// 绑定用户账户
export const bindUserAccount = (data) => {
  return apiClient.post('/wp-json/wallet/v1/bind', data);
};

// 获取品牌 Logo
export const fetchBrandLogo = () => {
  return apiClient.get('/wp-json/custom/v1/logo')
    .then(response => response.data)
    .catch(error => handleError(error));
};

// 错误处理函数
const handleError = (error) => {
  if (error.response) {
    console.error('Error response:', error.response.data);
    console.error('Error status:', error.response.status);
  } else if (error.request) {
    console.error('Error request:', error.request);
  } else {
    console.error('Error message:', error.message);
  }
  return Promise.reject(error);
};

// 获取主推产品
export const fetchFeaturedProduct = async () => {
    return apiClient.get('/wp-json/custom/v1/featured-product')
    .then(response => response.data)
    .catch(error => handleError(error));
}

export function checkout(orderData) {
  return apiClient.post('/wp-json/custom/v1/checkout', orderData)
  .then(response => response.data)
  .catch(error => {
    console.error('Error during checkout:', error);
    throw error;
  });
}

export const fetchCartItems = () => {
  return apiClient.get('/wp-json/custom/v1/cart')
  .then(response => response.data)
  .catch(error => handleError(error));
}

export const updateCartItem = (itemId, quantity) => {
  return apiClient.post('/wp-json/custom/v1/cart/update', {
    item_id: itemId,
    quantity,
  })
  .then(response => response.data)
  .catch(error => handleError(error))   ;
}

export const removeCartItem = (itemId) => {
  return apiClient.post('/wp-json/custom/v1/cart/remove', {
    item_id: itemId,
  })
  .then(response => response.data)
  .catch(error => handleError(error));
}

// Fetch user profile data
export const fetchUserProfile = () => {
  return apiClient.get('/wp-json/api/user/profile');
};

// Fetch user orders
export const fetchUserOrders = (status) => {
  return apiClient.get(`/wp-json/api/user/orders/${status}`);
};

// Fetch user addresses
export const fetchUserAddresses = (page) => {
  return apiClient.get(`/wp-json/api/user/addresses?page=${page}`);
};

// Fetch user earnings
export const fetchUserEarnings = (page) => {
  return apiClient.get(`/wp-json/api/user/earnings?page=${page}`);
};

// Fetch user invites
export const fetchUserInvites = () => {
  return apiClient.get('/wp-json/api/user/invites');
};

// Fetch user dashboard data
export const fetchUserDashboard = () => {
  return apiClient.get('/wp-json/api/user/dashboard');
};

// Fetch agent dashboard data
export const fetchAgentDashboard = () => {
  return apiClient.get('/wp-json/api/agent/dashboard');
};

// Fetch agent earnings data
export const fetchAgentEarnings = () => {
  return apiClient.get('/wp-json/api/agent/earnings');
};

export const fetchAgentSalesPerformance = () => {
  return apiClient.get("/wp-json/api/agent/salesPerformance");
};

export const checkUserFromAgent = (address) => {
  return apiClient.get(`/wp-json/api/agent/check-user/${address}`);
};

export const updateUserRoles = (address, role) => {
  return apiClient.post(`/wp-json/api/agent/update-user-roles/${address}`, { role });
};
// Update user nickname
export const updateUserNickname = (nickname) => {
  return apiClient.post('/wp-json/api/user/update-nickname', { nickname });
};

// Update user email
export const updateUserEmail = (email) => {
  return apiClient.post('/wp-json/api/user/update-email', { email });
};

export const getGlobalConfig = () => {
  return apiClient.get('/wp-json/custom/v1/global-config');
};

export const fetchOrderDetails = (orderId) => {
  return apiClient.get(`/wp-json/api/user/order/${orderId}`);
};

export const updateOrderAddress = (orderId, address) => {
  return apiClient.post(`/wp-json/api/user/order/${orderId}/update-address`, address);
};
